module.exports = __webpack_public_path__ + "static/media/ic_quici_product_setup.11908c88.svg";